webpackJsonp([62004951874236],{

/***/ 1412:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"[Tutorial] How to Set up a Rails 4.2 Mailer with Sidekiq","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/how-to-set-up-a-rails-4-2-mailer-with-sidekiq","createdAt":"2015-02-24T05:37:00.148Z","blogAuthor":{"fields":{"name":"Scott Hale & Javier Soto","slug":"blog/author/scott-hale-javier-soto"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/5TypZ1krdeGWiMgkuyCgm2/4c33beb3977f4e3a900bdbc03abfa307/blog-post-blog-how-to-set-up-a-rails-4-2-mailer-with-sidekiq.png"}}}}}]},"authorJson":{"name":"Scott Hale & Javier Soto","slug":"blog/author/scott-hale-javier-soto","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/scott-hale-javier-soto"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-scott-hale-javier-soto-8268cd30db609a4caa3c.js